<template>
  <Base>
    <template v-slot:contentBase>
      <div class="row">

        <div :class="[colMd, offset]">

          <div :class="formColor">

            <div class="panel-heading">
              <h3>
                <i :class="formIcon"></i>
                {{ formSubtitulo }}
              </h3>
            </div>

            <div class="panel-body">
                <slot name="inputForm"></slot>

            </div>

          </div>
        </div>
      </div>
    </template>
  </Base>
</template>

<script>
import Base from '@/components/base/Base.vue';

export default {
  name: 'BaseForm',
  components: {
    Base,
  },
  props: {
    colMd: {
      type: String,
      default: "col-lg-8",
    },
    offset: {
      type: String,
      default: "offset-2",
    },
    formColor: {
      type: String,
      default: "",
    },
    formIcon: {
      type: String,
      default: ""
    },
    formSubtitulo: {
      type: String,
      default: "Informações"
    },
  }
}
</script>
